Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Templates = Greenmile.Survey.Templates || {};
Greenmile.Survey.Templates.Sidebar = Greenmile.Survey.Templates.Sidebar || {};
Greenmile.Survey.Templates.Sidebar.SurveyEntityTemplate = function () {
  return new Monet.UI.LayoutGenerator({
    'items': [
      {
        'items': [
          {
            'attributes': {
              'class': 'SingleRowHeader',
            },
          },
          {
            'items': [
              {
                'items': [
                  {
                    'attributes': {
                      'class': 'gridActions ui-widget-header ',
                    },
                  },
                  {
                    'attributes': {
                      'class': 'gridContainer',
                    },
                  },
                ],
                'attributes': {
                  'class': 'MonetUIFormRelatedList',
                },
              },
              {
                'items': [
                  {
                    'attributes': {
                      'class': 'gridActionsCache ui-widget-header ',
                    },
                  },
                  {
                    'attributes': {
                      'class': 'gridContainerCache',
                    },
                  },
                ],
                'attributes': {
                  'class': 'MonetUIFormRelatedList',
                },
              },
            ],
            'attributes': {
              'class': 'content',
            },
          },
        ],
        'attributes': {
          'id': 'EntityQuestion',
          'class': 'entityQuestionContainer',
        },
      },
      {
        'tag': 'input',
        'attributes': {
          'type': 'hidden',
          'name': 'questionType',
          'value': 'ENTITY',
        },
      },
    ],
  }).render();
};
